/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I convert a CSV that has no header row?`)
};

const es_cj_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo convertir un CSV que no tiene fila de encabezado?`)
};

const de_cj_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich eine CSV-Datei ohne Kopfzeile konvertieren?`)
};

const nl_cj_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik een CSV converteren die geen koptelijnrij heeft?`)
};

const fr_cj_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je convertir un CSV qui n'a pas de ligne d'en-tête ?`)
};

const it_cj_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso convertire un CSV che non ha una riga di intestazione?`)
};

const pt_br2_cj_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso converter um CSV que não tem uma linha de cabeçalho?`)
};

const pt_cj_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso converter um CSV que não possui linha de cabeçalho?`)
};

const ja_cj_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘッダー行のない CSV を変換できますか？`)
};

const zh_cj_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以转换没有表头行的 CSV 吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_faq4_q", locale)
	if (locale === "en") return en_cj_faq4_q(inputs)
	if (locale === "es") return es_cj_faq4_q(inputs)
	if (locale === "de") return de_cj_faq4_q(inputs)
	if (locale === "nl") return nl_cj_faq4_q(inputs)
	if (locale === "fr") return fr_cj_faq4_q(inputs)
	if (locale === "it") return it_cj_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_cj_faq4_q(inputs)
	if (locale === "pt") return pt_cj_faq4_q(inputs)
	if (locale === "ja") return ja_cj_faq4_q(inputs)
	return zh_cj_faq4_q(inputs)
};